// extracted by mini-css-extract-plugin
export default {"main":"Contact_main__RKCv5","wrapper":"Contact_wrapper__GhGY5","form":"Contact_form__8+l07","cta":"Contact_cta__BG7u8","title":"Contact_title__0CFjZ"};